export enum MaintenanceProductStatusValue {
  USED = 'USED',
  NOT_USED = 'NOT_USED',
}

export class MaintenanceProductStatus {
  readonly value!: MaintenanceProductStatusValue

  constructor(value: MaintenanceProductStatusValue) {
    this.value = value
  }

  static fromString(value: string): MaintenanceProductStatus {
    if (!this.toList().includes(value as MaintenanceProductStatusValue)) {
      throw new Error(`Invalid MaintenanceStatus: ${value}`)
    }

    return new MaintenanceProductStatus(value as MaintenanceProductStatusValue)
  }

  static toList(): MaintenanceProductStatusValue[] {
    return Object.values(MaintenanceProductStatusValue)
  }

  static toEntries(): [MaintenanceProductStatusValue, MaintenanceProductStatus][] {
    return this.toList().map((value) => [ value, new MaintenanceProductStatus(value) ])
  }

  static readonly labels: Record<MaintenanceProductStatusValue, string> = {
    USED     : 'Usado',
    NOT_USED : 'Pendiente',
  }

  label(): string {
    return MaintenanceProductStatus.labels[this.value]
  }
}
